'use strict';
import accountBase from './accountBase';
import util from '../util';
import customModal from '../modal';
import newAddressForm from '../addressForm/address-form';
import validator from '../validator';
import orderHistory from './orderHistory';
import orderReturn from './orderReturn';
import optionalGDPR from '../optional-gdpr';
import checkoutAddress from './checkout/address';
import recaptcha from '../recaptcha';
import inputField from '../addressForm/input-field';
import index from './product/index';
import googleAddressAutocomplete from './checkout/googleAddressAutocomplete';
import createSlidePanel from '../slide-panel-module';
import validateBirthdayFiled from '../validate-birthday-filed';
import toast from '../toast-notify';
import ajax from '../ajax';
const slidePanel = createSlidePanel('#account-side-panel'); // Slide Panel
const isnewaccountpage = $('.account-content_new').length > 0 ? true : false;

// Event Listeners for Ajax Calls
$('.registered-account').on('click', '#edit-action-email', function () { // Edit Email
	var finalurl = Urls.getEmail;
	finalurl = util.appendParamToURL(finalurl, 'format', 'ajax');
	$.ajax({
		url: finalurl,
		dataType: 'html',
		success: function (response) {

			slidePanel.show((response), () => {
				const $accountPanel = $('#account-side-panel');
				$accountPanel.find('.panel-header h3').html(EDIT_EMAIL_HEADING).addClass('show');
				$accountPanel.find('#password_rules').remove();
				inputField.setEditMaterialFields('.user-email .material-input .input-text');
				validator.initForm('form[id="ChangeUsername"]');
				util.passwordShowHideToggle('form[id="ChangeUsername"]');
				validator.changeFieldValidation();
			}, 'user-email');
		}
	});
}).on('click', '#edit-action-info', function () { // Edit Personal Info
	var finalurl = Urls.getProfileDetails;
	finalurl = util.appendParamToURL(finalurl, 'format', 'ajax');
	$.ajax({
		url: finalurl,
		dataType: 'html',
		success: function (response) {

			slidePanel.show((response), () => {
				const $accountPanel = $('#account-side-panel');
				const $genderMenu = $('#dwfrm_profile_customer_gender');
				const selectedGender = $genderMenu.data('gender');
				$('select').selectmenu();
				$accountPanel.find('.panel-header h3').html(EDIT_PERSONAL_DETAILS_HEADING).addClass('show');
				$genderMenu.val(selectedGender);
				$genderMenu.selectmenu('refresh');
				inputField.setEditMaterialFields('.user-personal-info .material-input .input-text');
				validator.initForm('form[id="form-edit-profile"]');
				validator.changeFieldValidation();
				validateBirthdayFiled.init();
			}, 'user-personal-info');
		}
	});
}).on('click', '#modify-password-action', function () { // Modify Password
	var finalurl = Urls.getModifyPassword;
	finalurl = util.appendParamToURL(finalurl, 'format', 'ajax');
	$.ajax({
		url: finalurl,
		dataType: 'html',
		success: function (response) {

			slidePanel.show((response), () => {
				const $accountPanel = $('#account-side-panel');
				$accountPanel.find('.panel-header h3').html(EDIT_PASSWORD_HEADING).addClass('show');
				validator.initForm('form[id="ChangePasswordForm"]');
				util.passwordShowHideToggle('form[id="ChangePasswordForm"]');
				validator.changeFieldValidation();
			}, 'modify-password');
		}
	});
}).on('click', '.new-address-action', function (e) { // Add Address
	e.preventDefault();
	e.stopImmediatePropagation();
	var finalurl = Urls.checkoutAddAccountAddress;
	finalurl = util.appendParamToURL(finalurl, 'isSrcAccount', `${isnewaccountpage}`);
	finalurl = util.appendParamToURL(finalurl, 'format', 'ajax');
	$.ajax({
		url: finalurl,
		dataType: 'html',
		success: function (response) {

			showSlidePanel(response, 'set-new-address');
		}
	}).always(function (data) {
		initializeComponents();
		handlePhoneFieldFocus('.set-new-address');
	});
}).on('click', '.account-address-modify', function (e) { // Edit Address
	var element = document.getElementById(e.currentTarget.id);
	var addressID = element.dataset.addressId;
	var url = Urls.checkoutEditAccountAddress + encodeURIComponent(addressID);
	url = util.appendParamToURL(url, 'isSrcAccount', `${isnewaccountpage}`);
	url = util.appendParamToURL(url, 'format', 'ajax');
	$.ajax({
		url: url,
		dataType: 'html',
		success: function (response) {

			showSlidePanel(response, 'modify-address');
		}
	}).always(function (data) {
		initializeComponents();
		newAddressForm.populatePhoneFields($('.modify-address input[id$="_phone"]').val());
		handlePhoneFieldFocus('.modify-address');
		checkoutAddress.init();
	});
}).on('click', '.address-delete-action', function (e) { // Delete Address
	e.preventDefault();
	const href = $(this).attr('href');
	const $modal = $('.remove-address-modal');
	$modal.css('display', 'block');
	$modal.find('button[type="submit"]').attr('data-href', href);
}).on('click', '.saved-payment-delete-action', function (e) { // Delete Payment Method
	e.preventDefault();
	const $this = $(this);
	const $form = $this.parent('.remove-card-form');
	const href = $form.attr('action');
	const $modal = $('.remove-saved-payment-modal');
	const data = $form.serialize();
	$modal.css('display', 'block');
	$modal.find('button[type="submit"]').attr({
		'data-href': href,
		'data-cardvalue': $this.val(),
		'data-serialize': data
	});
});

// Event Listeners for Form Submission
$('.account-content_new').on('click', '#profile-save-changes', function (evt) { // Save changes in the profile
	evt.preventDefault();

	const $personalInfo = $('.customer-info-wrapper'); // Personal Info section
	const $form = $('#form-edit-profile'); // Edit Profile form
	const postData = $form.serialize() + '&dwfrm_profile_confirm=true&isRedesign=true'; // Form data
	var finalurl = Urls.editForm;
	finalurl = util.appendParamToURL(finalurl, 'isSrcAccount', `${isnewaccountpage}`);
	finalurl = util.appendParamToURL(finalurl, 'format', 'json');
	$.ajax({
		url: finalurl,
		type: 'POST',
		data: postData,
		success: function (response) {
			const { success, firstname, lastname, lastnametwo, gender, birthmonth, dob, birthyear, profileNationalIDNumber, profileNationalIDType } = response;
			if (success) {
				const $firstName = $personalInfo.find('#customer-firstname');
				const $lastName = $personalInfo.find('#customer-lastname');
				const $lastNameTwo = $personalInfo.find('#customer-lastname-two');
				const $gender = $personalInfo.find('#customer-gender');
				const $dob = $personalInfo.find('#customer-dob');
				const $profileNationalIDType = $personalInfo.find('#customer-national-type');
				const $profileNationalIDNumber = $personalInfo.find('#customer-national-number');

				const genderText = gender > 0 ? $('#dwfrm_profile_customer_gender').find(`option[value="${gender}"]`).text() : '-';
				const fiscalCode = $('#dwfrm_profile_customer_nationalIDType').val() === '';

				$firstName.text(firstname);
				$lastName.text(lastname);
				$lastNameTwo.text(lastnametwo);
				$gender.text(genderText);
				if (birthmonth == '00' || dob == '00' || birthyear == '00') {
					$dob.text('-');
				} else {
					$dob.text(`${dob}/${birthmonth}/${birthyear}`);
				}

				if (profileNationalIDType == null) {
					$profileNationalIDType.text('-');
					$profileNationalIDNumber.text('-');
				} else {
					$profileNationalIDType.text(fiscalCode ? '-' : profileNationalIDType);
					$profileNationalIDNumber.text(fiscalCode ? '-' : profileNationalIDNumber);
				}
				toast.init(NOTIFICATION_SUCCESS_PERSONAL_DETAILS, 'active animate__fadeInDownToast', 'hidden');
				slidePanel.close();
			} else {
				util.checkSessionTimeout(response);
				console.error('Error updating profile');
			}
		},
		error: function (xhr, status, error) {
			console.error(`AJAX request failed: ${error}`);
		}
	});
}).on('selectmenuchange', '#form-edit-profile select.gender', function (event, ui) { // Validate the gender
	$('#profile-save-changes').prop('disabled', false);
}).on('focus keyup change', '#form-edit-profile input.firstname, #form-edit-profile input.lastname, #form-edit-profile input.lastname2', function () { // Validate the first name and last name
	const $form = $('#form-edit-profile');
	const $firstName = $form.find('input.firstname');
	const $lastName = $form.find('input.lastname');
	const $submitButton = $form.find('button[type="submit"]');

	const isValid = $firstName.val().trim() !== '' && $lastName.val().trim() !== '';

	$submitButton.prop('disabled', !isValid);
}).on('click', '#ChangeUsername button[type="submit"]', function (e) { // Save changes in the username
	e.preventDefault();

	const form = $('#ChangeUsername');
	const data = form.serialize() + '&dwfrm_profile_changelogin=true&format=ajax';

	$.ajax({
		url: Urls.editForm,
		data: data,
		type: 'POST'
	}).done(function (response) {
		const $form = $('.customer-email-modify');
		const $accountSettingsBtn = $form.find('.account-settings-btn');

		util.checkSessionTimeout(response);

		function showError(selector) {
			$form.find(selector).removeClass('visually-hidden');
			$accountSettingsBtn.prop('disabled', true);
		}

		if (response.isEmailMatched === undefined) {
			showError('.email-taken');
			$form.find('.current-password-nomatch').addClass('visually-hidden');
		} else if (!response.isPasswordMatched) {
			showError('.current-password-nomatch');
			$form.find('.email-taken').addClass('visually-hidden');
		} else {
			if (response.success && response.isEmailMatched && response.isPasswordMatched) {
				$('#customer-username').text(response.email);
				toast.init(NOTIFICATION_SUCCESS_EMAIL, 'active animate__fadeInDownToast', 'hidden');
				slidePanel.close();
			}
		}
	});
}).on('click', '#ChangePasswordForm button[type="submit"]', function (e) { // Change Password 
	e.preventDefault();
	const form = $('#ChangePasswordForm');
	const data = form.serialize() + '&dwfrm_profile_changepassword=true&format=ajax';

	$.ajax({
		url: Urls.editForm,
		data: data,
		type: 'POST'
	}).done(function (response) {
		util.checkSessionTimeout(response);
		if (response.success) {
			toast.init(NOTIFICATION_SUCCESS_PASSWORD, 'active animate__fadeInDownToast', 'hidden');
			slidePanel.close();
		} else {
			$('.current-password-nomatch').removeClass('visually-hidden')
		}
	});
}).on('focus keyup change', '.customer-password-modify .new-password', function (e) { // New Password Validation
	util.validatePasswordInputs($(this))
}).on('click', '#EditAddressForm button[type="submit"]', function (e) { // Save changes in the address
	e.preventDefault();
	const form = $('#EditAddressForm');
	const $this = $(this);
	const isEdit = $this.parents('.account-side-panel').hasClass('modify-address');
	const data = form.serialize() + (isEdit ? '&dwfrm_profile_address_edit=Apply' : '&dwfrm_profile_address_create=Apply') + `&format=ajax&from=address&isSrcAccount=${isnewaccountpage}`;

	$.ajax({
		url: Urls.addressHandleForm,
		data: data,
		type: 'POST'
	}).done(function (response) {

		util.checkSessionTimeout(response);
		if (response) {
			$('.address-list-wrapper').html(response);
			isEdit ? toast.init(NOTIFICATION_SUCCESS_EDIT_ADDRESS, 'active animate__fadeInDownToast', 'hidden') : toast.init(NOTIFICATION_SUCCESS_ADDRESS, 'active animate__fadeInDownToast', 'hidden');
			slidePanel.close();
		}
	})
}).on('click', '.remove-saved-address', function (e) { // Delete Address
	e.preventDefault();
	let href = $(this).attr('data-href');

	href = util.appendParamToURL(href, 'isSrcAccount', `${isnewaccountpage}`);
	href = util.appendParamToURL(href, 'format', 'ajax');

	$.ajax({
		url: href,
		dataType: 'html'
	}).done(function (response) {
		util.checkSessionTimeout(response);
		$('.address-list-wrapper').html(response);
		toast.init(NOTIFICATION_SUCCESS_DELETE_ADDRESS, 'active animate__fadeInDownToast', 'hidden');
		$('.remove-address-modal').find('.modal-close').trigger('click');
	});
}).on('click', '.remove-saved-payment', function (e) { // Delete saved payment method
	e.preventDefault();
	const $this = $(this);

	let href = util.appendParamToURL(Urls.deleteCreditCard, 'isSrcAccount', `${isnewaccountpage}`);
	href = util.appendParamToURL(href, 'format', 'ajax');

	const formSerialize = $this.data('serialize');
	const data = `${formSerialize}&dwfrm_paymentinstruments_creditcards_storedcards_i0_remove=${$this.data('cardvalue')}`;

	$.ajax({
		url: href,
		data: data,
	}).done(function (response) {
		util.checkSessionTimeout(response);
		$('.payment-list-wrapper').html(response);
		toast.init(NOTIFICATION_SUCCESS_DELETE_PAYMENT, 'active animate__fadeInDownToast', 'hidden');
		$('.remove-saved-payment-modal').find('.modal-close').trigger('click');
	});
}).on('click', '.invoice-available', function (e) { // download invoice success
	e.preventDefault();
	$('.toast-container').removeClass("error-toast");
	$('.ajax-loader').show();
	$.ajax({
		url: util.appendParamToURL(Urls.downloadInvoiceFromSFSC, 'order_id', $('#order_id').val()),
		method: 'GET'
	})
		.done(function (response) {
			if (response.success) {
				downloadPDF(response.data, $('#order_id').val());
				toast.init(INVOICE_DOWNLOADED_SUCCESS, 'active animate__fadeInDownToast', 'hidden');
			} else {
				handlePdfDownloadErrror();
			}
			$('.ajax-loader').hide();
		}).fail(function () {
			handlePdfDownloadErrror();
		});
}).on('click', '.invoice-unavailable', function (e) { // download invoice unavailable
	e.preventDefault();
	toast.init(INVOICE_NOT_AVILABLE, 'active animate__fadeInDownToast error-toast', 'hidden');
}).on('click', '.download-invoice-from-modal', function (e) { // download invoice modal
	e.preventDefault();
	const $modal = $('.invoice-download-modal');
	$modal.css('display', 'block');
}).on('click', '.modal-invoice-close', function (e) {
	const $modal = $('.invoice-download-modal');
	$modal.css('display', 'none');
});

function handlePdfDownloadErrror() {
	const $modal = $('.invoice-download-modal');
	$modal.css('display', 'block');
	$(".download-credit").addClass("download-invoice-unavailable");
}

function downloadPDF(pdf, orderID) {
	base64toPDF(pdf, orderID);
}

function base64toPDF(data, orderID) {
	var bufferArray = base64ToArrayBuffer(data);
	var blobStore = new Blob([bufferArray], { type: "application/pdf" });
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		window.navigator.msSaveOrOpenBlob(blobStore);
		return;
	}
	var data = window.URL.createObjectURL(blobStore);
	var link = document.createElement('a');
	var fileName = orderID + ".pdf";
	document.body.appendChild(link);
	link.setAttribute('href', data);
	link.setAttribute('download', fileName);
	link.click();
	window.URL.revokeObjectURL(data);
	document.body.removeChild(link);
}

function base64ToArrayBuffer(data) {
	var bString = window.atob(data);
	var bLength = bString.length;
	var bytes = new Uint8Array(bLength);
	for (var i = 0; i < bLength; i++) {
		var ascii = bString.charCodeAt(i);
		bytes[i] = ascii;
	}
	return bytes;
};

// helper methods for Add/Edit Address
function showSlidePanel(response, panelClass) {
	slidePanel.show(response, () => {
		const $accountPanel = $('#account-side-panel');
		const headerText = $accountPanel.hasClass('set-new-address') ? EDIT_ADD_ADDRESS : EDIT_ADDRESS;

		$accountPanel.find('.panel-header h3').html(headerText).addClass('show');
		util.limitCharacters();
	}, panelClass);
	util.bodyPositionFixed(panelClass);
	!$('.modify-address .focus-in .phonenumber').val() && $('.modify-address .phonenumber').closest('.focus-in').removeClass('focus-in');
	googleAddressAutocomplete.init();
}

function initializeComponents() {
	$('select').selectmenu();
	inputField.setEditMaterialFields('.modify-address .material-input .input-text');
	validator.initStateValidation();
	validator.initCountryChangeValidation();
	validator.initForm('form[id="EditAddressForm"]');
	newAddressForm.init();
	googleAddressAutocomplete.init();
}

const handlePhoneFieldFocus = (selector) => {
	const $phoneField = $(`${selector} .focus-in .phonenumber`);
	if (!$phoneField.val()) {
		$phoneField.closest('.focus-in').removeClass('focus-in');
	}
};

const handleScrollFavorites = () => {
	const $container = $('.account-navigation-list');
	const $lastItem = $container.children().last();
	if ($lastItem.length && $('.wishlist-section-header').length && window.innerWidth < 414) {
		// Scroll last item into view with smooth animation
		$lastItem.get(0).scrollIntoView({ behavior: 'smooth', inline: 'end', block: 'nearest' });
	}
}
handleScrollFavorites(); // Scroll to the last item in the favorites list

// reason change on return page
function handleReturnInputChange($input) {
	const SELECT_REASON = 'Select Reason';
	const $quantityColumn = $input.closest('.quantity-column');
	const $reason = $quantityColumn.find('.returnreason');
	const $qty = $quantityColumn.find('.return-qty');
	const reasonVal = $reason.val();
	const qtyVal = $qty.val();
	const $selectMenuBtn = $input.next(".ui-selectmenu-button");
	if (reasonVal != SELECT_REASON && qtyVal > 0) {
		$selectMenuBtn.removeClass("error-text");
		$(".productReturn #return").removeClass("disabled-cta");
	} else {
		$selectMenuBtn.addClass("error-text");
	}
	checkReturnBtnStatus();
}

$('.returnreason, .return-qty').on('selectmenuchange change', function () {
	handleReturnInputChange($(this));
});

// return page submit button
$('.productReturn button#new-return').on('click', onReturnSubmit);

// quantity change on return page
$('.return-qty').on('selectmenuchange change', onQtyChange);

function onQtyChange() {
	let totalQty = calculateTotalQty(this);
	$('.returnQuantity').text(totalQty);
	checkReturnBtnStatus();
}

// calculate quantity of item
function calculateTotalQty(elem) {
	let totalQty = 0;
	const $element = $(elem);
	$('.return-qty').each(function () {
		totalQty = totalQty + Number($(this).val());
	});
	if (totalQty > 0) {
		$element.next(".ui-selectmenu-button").removeClass("error-text");
	} else {
		$element.next(".ui-selectmenu-button").addClass("error-text");
	}
	return totalQty;
}

function checkReturnBtnStatus() {
	if (!$(".error-text").length) {
		$('.ordered-items .item-detail-row').each(function () {
			const $this = $(this);
			if ($this.find('.returnreason').val() == 'Select Reason' && $this.find('.return-qty').val() == 0) {
				$(".quantity-column .reason .ui-selectmenu-button").addClass("error-text");
				$(".productReturn #return").addClass("disabled-cta");
			} else {
				$(".productReturn #return").removeClass("disabled-cta");
			}
		});
	}
}

// function to submit return request
function onReturnSubmit() {
	let totalQty = calculateTotalQty();
	let isError = false;

	if (totalQty == 0) {
		toast.init(QUANTITY_ERROR, 'active animate__fadeInDownToast error-toast', 'hidden');
		isError = true;

		//To throw error when qty is not selected but reason is selected
		$('.ordered-items .item-detail-row').each(function () {
			const $this = $(this);
			if ($this.find('.returnreason').val() != 'Select Reason') {
				if ($this.find('.return-qty').val() == 0) {
					toast.init(QUANTITY_ERROR, 'active animate__fadeInDownToast error-toast', 'hidden');
				}
			} else {
				toast.init(GENERIC_ERROR, 'active animate__fadeInDownToast error-toast', 'hidden');
			}
		});
	} else {
		$('.ordered-items .item-detail-row').each(function () {
			const $this = $(this);
			if ($this.find('.return-qty').val() > 0) {
				if ($this.find('.returnreason').val() == 'Select Reason') {
					toast.init(REASON_ERROR, 'active animate__fadeInDownToast error-toast', 'hidden');
					$(".quantity-column .reason .ui-selectmenu-button").addClass("error-text");
					isError = true;
				}
			} else if ($this.find('.return-qty').val() == 0) {
				if ($this.find('.returnreason').val() == 'Select Reason') {
					toast.init(GENERIC_ERROR, 'active animate__fadeInDownToast error-toast', 'hidden');
				}
			}

			if ($this.find('.returnreason').val() != 'Select Reason') {
				if ($this.find('.return-qty').val() == 0) {
					toast.init(QUANTITY_ERROR, 'active animate__fadeInDownToast error-toast', 'hidden');
					isError = true;
				}
			}
		});
	}

	var commentMessage = $('textarea[name*="returnComments"]').val();
	if (commentMessage != '') {
		if (!util.validateMessage(commentMessage)) {
			toast.init(COMMENTS_ERROR, 'active animate__fadeInDownToast error-toast', 'hidden');
			isError = true;
		}
	}

	if (isError) {
		$(".productReturn #return").addClass("disabled-cta");
		return false;
	} else {
		$(".productReturn #return").removeClass("disabled-cta");
		$('.toast-container').removeClass("error-toast");
		toast.init(SUBMIT_RETURN, 'active animate__fadeInDownToast', 'hidden');
	}
}
// return request js ends here

$('a.prepaid-label-new').on('click', downloadPrepaidLabel);
$('a.prepaid-dhl-label-new').on('click', downloadRoyalmailPrepaidLabel);

/*
 * Download Prepaid label
 */
function downloadPrepaidLabel(e) {
	e.preventDefault();
	const $this = $(this);
	$(this).attr('disabled', 'disabled');
	const perpaidURL = $(this).data('prepaid-url');

	ajax.getJson({
		url: perpaidURL,
		callback: function (response) {
			if (response.result == 'success') {
				toast.init(response.msg, 'active animate__fadeInDownToast', 'hidden');
			} else {
				toast.init(response.msg, 'active animate__fadeInDownToast error-toast', 'hidden');
			}
			$this.removeAttr('disabled');
		}
	});
}

/*
	 * Download Royalmail Prepaid label
	 */
function downloadRoyalmailPrepaidLabel(e) {
	e.preventDefault();
	let pdfEncodedData = $(this).data('pdf-encoded');
	const $this = $(this);
	const filename = $(this).attr('download');
	$(this).attr('disabled', 'disabled');

	if (pdfEncodedData == '') {
		const that = this;
		const perpaidURL = $(this).data('prepaid-url');

		ajax.getJson({
			url: perpaidURL,
			callback: function (response) {
				if (!response || response.outputImage == '') {
					$(that).removeAttr('disabled');
					$this.parents('.print-slips-block').find('#prepaid-msg').text(response.msg);
					toast.init(response.msg, 'active animate__fadeInDownToast error-toast', 'hidden');
					$this.removeAttr('disabled');
					return false;
				}
				pdfEncodedData = response.outputImage;
				getPrepaidLabelPDF(pdfEncodedData, filename, that);
				$(that).data('pdf-encoded', pdfEncodedData);
			}
		});
	} else {
		getPrepaidLabelPDF(pdfEncodedData, filename, this);
	}
}

function getPrepaidLabelPDF(pdfEncodedData, filename, clickEle) {
	var blob = getBlob(pdfEncodedData);

	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		window.navigator.msSaveOrOpenBlob(blob, filename);
	} else {
		var link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
		link.href = URL.createObjectURL(blob);
		link.download = filename;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	$(clickEle).removeAttr('disabled');
}

function getBlob(base64Data) {
	var byteCharacters = atob(base64Data);
	var byteNumbers = new Array(byteCharacters.length);
	for (var i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	var byteArray = new Uint8Array(byteNumbers);
	return new Blob([byteArray], { type: 'application/pdf;charset=utf-8' });
}

const initContactUs = () => {
	const inquiryEl = $('.myquestion, .myquestionmkt');
	let isFormSubmitted = false;

	inquiryEl.addClass('required');

	// Use arrow functions for cleaner event handlers
	$(".contact-us-page .primary--l").on('click', (e) => {
		e.stopPropagation();
		validator.initInquiryValidation();
		util.scrollToError($('html, body'), $(".error-placement, input.error, span.dropdownerror"), 500);
	});

	$('.js-inquiry select, .js-inquiry .ui-selectmenu-button').focus(function () {
		// 'this' context preserved via arrow function if needed, 
		// but here we use $(this) for jQuery scope
		$(this).on("blur", () => validator.initInquiryValidation());
	});

	inquiryEl.on('selectmenuchange change', (e) => {
		checkOrderNumber($(e.currentTarget).val());
	});
	
	const showSuggestion = (key) => {
		if (!key) {
			$(".suggestions:visible").slideUp(500);
			return;
		}
		const $target = $(`.suggestions[data-key="${key}"]`);

		$(".suggestions:visible").not($target).slideUp(500);

		if (!$target.is(":visible")) {
			$target.slideDown(500);
		}
	};

	$(".contact-us-page").on("click", ".js-inquiry li", function () {
		const key = $(this).data("key");
		showSuggestion(key);
	});

	$(".contact-us-page").on("change", ".js-inquiry select", function () {
		const key = $(this).find("option:selected").attr("key");
		showSuggestion(key);
	});
	
	$(".suggestion-question").on("click", function() {
		const $this = $(this);
		const $answer = $this.next(".suggestion-answer");

		if ($this.hasClass("active")) {
			$this.removeClass("active");
			$answer.slideUp(800);
		} else {
			$(".suggestion-question").removeClass("active");
			$(".suggestion-answer").slideUp();

			$this.addClass("active");
			$answer.slideDown(800);
		}
	});

	// Registration Form Logic
	$('#RegistrationForm button#sendBtn').on('click', (e) => {
		e.preventDefault();
		e.stopImmediatePropagation();

		const inquiryValue = $('.js-inquiry select').val();

		if (checkOrderNumber(inquiryValue)) {
			$.ajax({
				url: util.appendParamToURL(Urls.customerServiceSubmit, 'format', 'ajax'),
				data: $('#RegistrationForm').serialize(),
				method: 'POST'
			})
				.done((response) => {
					if (response.status) {
						const modalBody = $('#contact-response').html();
						customModal.createCustomModal('customer-contact-us-modal', '#modal-custom-placeholder');
						$('.customer-contact-us-modal').find('.modal-body').html(modalBody);
						$(document).trigger("gtmcontactus");
						clearContactUsForm();
					}
				});
		}
	});

	// Contact Us Form Submission with Recaptcha
	$('form.contact-us-form .contactus-submit').on('click', function (e) {
		const $form = $('form.contact-us-form');
		const $submitBtn = $(this);

		if (!$form.valid()) return false;

		const isRecaptchaEnabled = recaptcha.getGoogleRecaptchaEnableStatus(recaptcha.source.CONTACT_US);

		if (!isFormSubmitted && isRecaptchaEnabled) {
			try {
				$submitBtn.attr("disabled", true);

				recaptcha.generateRecaptchaToken(e, recaptcha.source.CONTACT_US, (token) => {
					const submitURL = util.appendParamToURL(Urls.customerServiceSubmit, 'captchaToken', token);

					$.ajax({
						url: util.appendParamToURL(submitURL, 'format', 'ajax'),
						data: $('#ContactUsForm').serialize(),
						method: 'POST',
						async: false // Note: synchronous AJAX is deprecated in modern browsers
					})
						.done((response) => {
							if (response.status) {
								// Using Template Literals and Object shorthand for cleaner DOM injection
								const hiddenInputs = `
                                <input name="orgid" type="hidden" value="${response.orgid}">
                                <input name="retURL" type="hidden" value="${response.returnUrl}">
                            `;
								$("#ContactUsForm").append(hiddenInputs);
								$("#ContactUsForm").attr('action', response.targetUrl);

								isFormSubmitted = true;
								$submitBtn.trigger('click');
							} else {
								recaptcha.displayRecaptchaError(response.errorMsg);
								$submitBtn.removeAttr("disabled");
							}
						});
				});
			} catch (err) {
				console.error(`Recaptcha Error - ${err.message}`);
				isFormSubmitted = false;
				$submitBtn.removeAttr("disabled");
			}
		} else {
			isFormSubmitted = false;
		}
	});

	$('.contact-us-form select[id$="_country"]').on('selectmenuchange change', (e) => {
		util.prePopulateCallingCountryCode(e.currentTarget.value);
	});
};

const checkOrderNumber = (selectedValue) => {
	const $orderWrapper = $('.js-order-number');
	const $orderInput = $orderWrapper.find('input');

	// 1. Guard clause: Handle empty selection immediately
	if (!selectedValue) {
		validator.initInquiryValidation();
		return false;
	}

	// 2. Use Array.includes() for cleaner multi-condition checks
	const requiresOrderNumber = ['Order tracking / delivery', 'Invoice request'].includes(selectedValue);

	if (requiresOrderNumber) {
		const hasValue = !!$orderInput.val();

		if (hasValue) {
			return true;
		}

		// Show and make required
		$orderWrapper.show().removeClass('hidden').addClass('required');
		$orderInput.addClass('required');
		return false;
	}

	// 3. Logic for when order number is NOT required
	$orderInput.removeClass('required error').val('');
	$orderWrapper.removeClass('required').addClass('hidden').hide();
	$orderWrapper.find('.error-placement').remove();

	validator.initInquiryValidation();

	// Enable button if no errors exist
	const errorCount = $("#RegistrationForm").find('span.error').length;
	if (errorCount === 0) {
		$(".contact-us-page .primary--l").prop('disabled', false);
	}

	return true;
};
/**
 * Clear contact us form
 */
const clearContactUsForm = () => {
	// 1. Check authentication status (using strict inequality)
	if (window.User?.isCustomerAuthenticated === false) {
		const personalFields = ['firstname', 'lastname', 'email'];

		// Loop through fields to avoid repetitive code
		personalFields.forEach(field => {
			$(`input[name$="_contactus_${field}"]`).val('');
		});

		$('input[name$="_phoneNumber"]').val('');
	}

	// 2. Reset dropdowns and clear validation UI
	$('select.myquestion, select.myquestionmkt').val('').change();

	// Using a single selector to clean up multiple error elements
	const $inquiryContainer = $('.js-inquiry');
	$inquiryContainer.find('.error-placement').remove();
	$inquiryContainer.find('span.ui-selectmenu-button').removeClass('dropdownerror');

	// 3. Reset specific form fields
	const formResets = {
		'input[name$="_contactus_ordernumber"]': '',
		'textarea[name$="_contactus_comment"]': '',
	};

	// Example of using Object.entries to iterate resets if the list grows
	Object.entries(formResets).forEach(([selector, value]) => {
		$(selector).val(value).change();
	});

	// 4. Reset checkboxes and visibility
	$('input[name$="_userconsent_termsandconditions"]').prop("checked", false);
	$('.js-order-number').hide();
};

/**
 * get default country code
 */
const getCountryCode = () => {
	// 1. Capture the value using a scoped constant
	const countryCode = $('select[id$="_country"]').val();

	// 2. Execute utility functions
	util?.prePopulateCallingCountryCode(countryCode);
	newAddressForm?.updatePlaceholderValue();
};

/**
 * combine country code with phone number
 */
const getPhoneNumWithCode = () => {
	const $phoneNumberInput = $('input[class~="phonenumber"]');
	const $areaCodeInput = $('input[class~="areacode"]');

	// 1. Guard Clause: Check existence using .length
	if (!$areaCodeInput.length && !$phoneNumberInput.length) {
		return;
	}

	// 2. Use Arrow function for the event handler
	// We use a standard function(e) if we need $(this), 
	// but e.currentTarget is cleaner in modern JS.
	$('.contact-us-form').on('focusout', 'input[class~="phonenumber"]', (e) => {
		const phoneNumber = $(e.currentTarget).val();
		const selectedCountryCode = $('select[id$="_country"]').data('country');

		// 3. Format phone number
		const custFoneNumb = util?.getFormattedPhoneNumber(phoneNumber, selectedCountryCode);

		// 4. Batch update values
		$('input[class~="phone"], #contactusphone').val(custFoneNumb);

		// 5. Trigger validation
		validator?.initCountryChangeValidation();
	});
};

const downloadInvoiceModal = () => {
	// 1. First Modal: Fetching invoice HTML message
	$('.download-invoice-modal').on('click', (e) => {
		e.preventDefault();

		$.ajax({
			url: util.appendParamToURL(Urls.downloadInvoice, 'format', 'ajax'),
			method: 'GET'
		})
			.done(({ message }) => { // Destructuring 'message' from response
				if (message) {
					const modalClass = 'download-invoice-modal';
					customModal.createCustomModal(modalClass, '#modal-custom-placeholder');

					const $modalBody = $(`.${modalClass}`).find('.modal-body');
					$modalBody.html(message).scrollBox();
				}
			});
	});

	// 2. Second Modal: Fetching PDF data from SFSC
	$('.download-invoice-from-sfsc').on('click', (e) => {
		e.preventDefault();

		const $loader = $('.ajax-loader');
		const orderId = $('#order_id').val();
		const modalClass = 'download-invoice-from-sfsc';

		$loader.show();

		$.ajax({
			url: util.appendParamToURL(Urls.downloadInvoiceFromSFSC, 'order_id', orderId),
			method: 'GET'
		})
			.done(({ success, data }) => { // Destructuring response object
				if (success) {
					downloadPDF(data, orderId);
				} else {
					customModal.createCustomModal(modalClass, '#modal-custom-placeholder');

					const $modalBody = $(`.${modalClass}`).find('.modal-body');
					$modalBody.html(data).scrollBox();
				}
			})
			.always(() => $loader.hide()); // Ensures loader hides even if request fails
	});
};

const characterLimitEvents = () => {
	// 1. Use more descriptive key names or a Set for O(1) lookup
	const controlKeys = new Set(['Backspace', 'Enter', 'Delete', 'Insert', 'Home', 'End', 'ArrowUp', 'ArrowLeft', 'ArrowDown', 'ArrowRight']);

	$('body')
		.on('keydown', '[data-character-limit]', (e) => {
			const $this = $(e.currentTarget);
			const charsLimit = $this.data('character-limit');
			const charsUsed = $this.val().length;

			// 2. Use e.key (standard) instead of e.which (deprecated)
			if (charsUsed >= charsLimit && !controlKeys.has(e.key)) {
				e.preventDefault();
			}
		})
		.on('change keyup mouseup', '[data-character-limit]', (e) => {
			const $this = $(e.currentTarget);
			const charsLimit = $this.data('character-limit');
			let text = $this.val();
			let charsUsed = text.length;
			let charsRemain = charsLimit - charsUsed;

			// 3. Clean slice logic
			if (charsRemain < 0) {
				$this.val(text.slice(0, charsLimit));
				charsRemain = 0;
				charsUsed = charsLimit;
			}

			// 4. Cache the wrapper search
			const $wrapper = $this.closest('.field-wrapper');
			$wrapper.find('.char-remain-count').text(charsRemain);
			$wrapper.find('.char-used-count').text(charsUsed);
		});
};

var account = {
	init: function () {
		accountBase.init();
		initContactUs();
		getCountryCode();
		getPhoneNumWithCode();
		orderReturn.init();
		orderHistory.init();
		optionalGDPR.init();
		checkoutAddress.init();
		downloadInvoiceModal();
		characterLimitEvents();
	},
	initCartLogin: function () {
		accountBase.initCartLogin();
	},
	characterLimitEvents: characterLimitEvents
}

export default account;

